<template>
    <div>
      <div class="tj">
        <div class="ql-container ql-snow" :class="showBtn ? hiddenContent : ''">
            <div class="ql-editor">
                <div class="details_box" v-html="data"></div>
            </div>
        </div>
        <div v-show="data.length > 80" class="btnWord" @click="showBtn = !showBtn">{{ showBtn ? tip : "收起" }}</div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "TextExpansion",
        data() {
            return {
                showBtn: true,
                hiddenContent: 'hiddenContent'
            };
        },
        props: {
            tip: {
                type: String,
                default: "展开",
            },
            // 数据
            data: {
                type: String,
                default: "",
            },
        },
    };
</script>

<style lang="scss">
    .tj {
        text-align: justify;
        line-height: 1.8em;
        display: inline-block;
    }

    .btnWord {
        color: cornflowerblue;
        cursor: pointer;
        word-break: keep-all;
    }

    .hiddenContent .details_box {
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .ql-container.ql-snow {
        border: none;
    }
</style>
